import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "_flex _gap-3 _pos-r" }
const _hoisted_2 = { "format-key": "0" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_image = _resolveComponent("base-image")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_base_title = _resolveComponent("base-title")
  const _component_localize = _resolveComponent("localize")
  const _component_balloon_actions = _resolveComponent("balloon-actions")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['_py-3 _bdb--thick', $options.borderColorClass])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_base_image, {
        src: $options.imageUrl,
        alt: $props.name,
        class: "_rounded--common",
        loading: "lazy",
        width: "120",
        height: "120"
      }, null, 8 /* PROPS */, ["src", "alt"]),
      _createElementVNode("div", null, [
        _createVNode(_component_base_title, {
          as: "h3",
          level: $options.headerLevel,
          "data-qa": "cart-table:ProductName"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($props.name) + " ", 1 /* TEXT */),
            ($props.tooltipMessage)
              ? (_openBlock(), _createBlock(_component_tooltip, {
                  key: 0,
                  text: $props.tooltipMessage,
                  class: "gfu-gift-card-picker__tooltip",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_base_icon, {
                      name: "circle-info",
                      size: "xs"
                    })
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["text"]))
              : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["level"]),
        _createVNode(_component_base_title, {
          level: $options.headerLevel,
          "data-qa": "cart-table:ProductPrice"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($options.priceFormatted), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["level"]),
        ($props.handleTax)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(['gfu-bt', $options.descriptionClasses, '_tc--light'])
            }, [
              _createElementVNode("span", null, [
                (_openBlock(), _createBlock(_component_localize, {
                  key: $options.taxFormatted,
                  resource: _ctx.Resources.YourPledge.CartTableOrderItemTaxValueLabel
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_2, _toDisplayString($options.taxFormatted), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["resource"]))
              ])
            ], 2 /* CLASS */))
          : _createCommentVNode("v-if", true)
      ]),
      ($options.hasActions)
        ? (_openBlock(), _createBlock(_component_balloon_actions, {
            key: 0,
            actions: $options.balloonActions,
            mode: $options.balloonActionMode,
            theme: "white",
            class: _normalizeClass(['_right-0', '_top-a', $options.balloonActionClasses])
          }, null, 8 /* PROPS */, ["actions", "mode", "class"]))
        : _createCommentVNode("v-if", true)
    ])
  ], 2 /* CLASS */))
}